function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 0.105469 0.375 C 0.0429688 0.59375 0.0195312 7.3125 0.0429688 15.3125 L 0.105469 29.84375 L 29.894531 29.84375 L 29.894531 0.15625 L 15.042969 0.0625 C 3.277344 0 0.171875 0.0625 0.105469 0.375 Z M 29.035156 15 L 29.035156 28.59375 L 0.964844 28.59375 L 0.898438 15.3125 C 0.878906 8 0.898438 1.84375 0.964844 1.625 C 1.027344 1.3125 3.964844 1.25 15.042969 1.3125 L 29.035156 1.40625 Z M 29.035156 15 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.570312 4.21875 C 2.570312 4.84375 2.679688 5 3.105469 5 C 3.535156 5 3.644531 4.84375 3.644531 4.21875 C 3.644531 3.59375 3.535156 3.4375 3.105469 3.4375 C 2.679688 3.4375 2.570312 3.59375 2.570312 4.21875 Z M 2.570312 4.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 4.929688 4.21875 C 4.929688 4.78125 5.035156 5 5.355469 5 C 5.679688 5 5.785156 4.78125 5.785156 4.21875 C 5.785156 3.65625 5.679688 3.4375 5.355469 3.4375 C 5.035156 3.4375 4.929688 3.65625 4.929688 4.21875 Z M 4.929688 4.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 7.070312 4.21875 C 7.070312 4.78125 7.179688 5 7.5 5 C 7.820312 5 7.929688 4.78125 7.929688 4.21875 C 7.929688 3.65625 7.820312 3.4375 7.5 3.4375 C 7.179688 3.4375 7.070312 3.65625 7.070312 4.21875 Z M 7.070312 4.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.785156 6.71875 L 2.785156 7.5 L 27 7.5 L 27 5.9375 L 2.785156 5.9375 Z M 2.785156 6.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.070312 10.3125 C 9.8125 10.5625 9.921875 10.84375 10.671875 11.9375 C 11.65625 13.4375 11.742188 13.78125 11.25 14.375 C 10.949219 14.71875 10.777344 14.59375 10.007812 13.5 C 9.492188 12.78125 8.980469 12.1875 8.851562 12.1875 C 8.507812 12.1875 8.269531 14.09375 8.441406 15.40625 C 8.527344 16 8.894531 16.90625 9.320312 17.5 C 9.941406 18.375 10.242188 18.5625 11.292969 18.6875 L 12.535156 18.8125 L 14.679688 21.875 C 15.855469 23.5625 17.015625 25.03125 17.269531 25.125 C 17.894531 25.40625 18.855469 24.25 18.855469 23.21875 C 18.855469 22.625 18.300781 21.59375 16.671875 19.1875 C 14.527344 16 14.484375 15.90625 14.484375 14.4375 C 14.464844 12.6875 13.992188 11.5 13.007812 10.625 C 12.277344 9.96875 10.628906 9.78125 10.070312 10.3125 Z M 12.984375 12 C 14.570312 14.3125 13.519531 17.8125 11.25 17.8125 C 10.265625 17.8125 9 16.15625 9 14.875 C 9 13.9375 9.234375 13.84375 9.664062 14.5625 C 10.113281 15.375 10.886719 15.6875 11.421875 15.28125 C 12.386719 14.53125 12.472656 13.3125 11.65625 11.90625 L 11.101562 10.9375 L 11.679688 10.9375 C 12.042969 10.9375 12.515625 11.3125 12.984375 12 Z M 18.171875 23.4375 C 18.128906 23.6875 17.914062 23.9375 17.679688 24 C 17.378906 24.0625 16.628906 23.1875 15.234375 21.125 C 13.222656 18.15625 13.199219 18.15625 13.605469 17.5 L 14.015625 16.84375 L 16.113281 19.90625 C 17.269531 21.59375 18.191406 23.1875 18.171875 23.4375 Z M 18.171875 23.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 18.429688 11.96875 C 18.257812 12.1875 17.570312 13.15625 16.949219 14.15625 C 16.15625 15.375 15.855469 16.0625 16.007812 16.28125 C 16.15625 16.5 16.5 16.21875 17.078125 15.40625 C 17.570312 14.75 18.257812 13.8125 18.621094 13.3125 C 19.265625 12.46875 19.394531 11.875 18.941406 11.65625 C 18.835938 11.625 18.601562 11.75 18.429688 11.96875 Z M 18.429688 11.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.4375 21.5 C 9.75 22.5 9.214844 23.59375 9.214844 23.9375 C 9.214844 24.5625 10.4375 26.5625 10.84375 26.5625 C 11.164062 26.5625 13.820312 22.53125 13.648438 22.28125 C 13.5625 22.15625 13.007812 22.75 12.449219 23.5625 C 11.679688 24.65625 11.292969 25.03125 11.015625 24.875 C 10.691406 24.6875 10.820312 24.40625 11.785156 22.96875 C 12.429688 22.03125 12.878906 21.15625 12.792969 21.03125 C 12.707031 20.90625 12.171875 21.46875 11.613281 22.28125 C 11.058594 23.09375 10.480469 23.75 10.328125 23.75 C 9.8125 23.75 10.09375 22.90625 11.035156 21.5625 C 11.957031 20.25 12.191406 19.6875 11.828125 19.6875 C 11.742188 19.6875 11.121094 20.5 10.4375 21.5 Z M 10.4375 21.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 22.929688 22.96875 L 22.929688 25.9375 L 26.808594 25.9375 L 26.742188 23.03125 L 26.679688 20.15625 L 24.8125 20.0625 L 22.929688 19.96875 Z M 22.929688 22.96875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCards);
export default __webpack_public_path__ + "static/media/customCards.5ff9cc13df5b8efe0c7867c5b6ba5f76.svg";
export { ForwardRef as ReactComponent };